// Historial completo con filtros por bodega y tipo. Port de views/movimientos.js.
import { useMemo, useState } from 'react';
import { useMovimientos } from '../hooks/useMovimientos';
import { useBodegas } from '../hooks/useBodegas';
import { DataTable, type Column } from '../components/DataTable';
import { TipoBadge } from '../components/Badge';
import { SkeletonTable } from '../components/Skeletons';
import { ErrorBox } from '../components/ErrorBox';
import { fechaBogota, horaBogota } from '../lib/fecha';
import type { Movimiento } from '../types';

export function Movimientos() {
  const { data: movimientos, isLoading, isError, error } = useMovimientos({});
  const { data: bodegas } = useBodegas();
  const [fBodega, setFBodega] = useState('');
  const [fTipo, setFTipo] = useState('');

  const tipos = useMemo(
    () => [...new Set((movimientos ?? []).map((m) => m.tipo).filter(Boolean))],
    [movimientos],
  );

  const filtrados = useMemo(() => {
    let rows = movimientos ?? [];
    if (fBodega) rows = rows.filter((m) => m.bodega_origen === fBodega || m.bodega_destino === fBodega);
    if (fTipo) rows = rows.filter((m) => m.tipo === fTipo);
    return rows;
  }, [movimientos, fBodega, fTipo]);

  const cols: Column<Movimiento>[] = [
    { key: 'created_at', label: 'Fecha', render: (r) => (<>{fechaBogota(r.created_at)}<br /><small className="text-muted">{horaBogota(r.created_at)}</small></>) },
    { key: 'tipo', label: 'Tipo', render: (r) => <TipoBadge tipo={r.tipo} /> },
    { key: 'item_nombre', label: 'Ítem', render: (r) => r.item_nombre || '—' },
    { key: 'cantidad', label: 'Cant.', render: (r) => (r.cantidad != null ? <b>{r.cantidad}</b> : '—') },
    { key: 'usuario', label: 'Usuario', render: (r) => r.usuario || '—' },
    { key: 'descripcion', label: 'Detalle', render: (r) => <small className="text-muted">{r.descripcion}</small> },
  ];

  return (
    <>
      <div className="page-head"><h2>Historial de movimientos</h2></div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div className="row wrap" style={{ gap: 12 }}>
          <div className="field" style={{ margin: 0, minWidth: 180 }}>
            <label>Bodega</label>
            <select className="control" value={fBodega} onChange={(e) => setFBodega(e.target.value)}>
              <option value="">Todas</option>
              {(bodegas ?? []).map((b) => <option key={b.id} value={b.id}>{b.nombre}</option>)}
            </select>
          </div>
          <div className="field" style={{ margin: 0, minWidth: 180 }}>
            <label>Tipo</label>
            <select className="control" value={fTipo} onChange={(e) => setFTipo(e.target.value)}>
              <option value="">Todos</option>
              {tipos.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <button className="btn secondary sm" style={{ alignSelf: 'flex-end' }} onClick={() => { setFBodega(''); setFTipo(''); }}>
            <i className="fa-solid fa-eraser" /> Limpiar
          </button>
        </div>
      </div>

      {isLoading ? (
        <SkeletonTable rows={8} />
      ) : isError ? (
        <ErrorBox mensaje={(error as Error).message} />
      ) : (
        <DataTable title="Registro de operaciones" pageSize={12} cols={cols} rows={filtrados} empty="No hay movimientos con estos filtros." />
      )}
    </>
  );
}
